import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/ChatGPT Image Aug 24, 2026, 01_52_21 PM.png';

const BusinessIndustry = () => {
  return (
    <IndustryPageTemplate
      title="Business"
      subtitle="Grow Your Brand and Corporate Identity"
      desc="Create professional content that grows your brand and business. Seamlessly develop corporate communications, presentations, and product demos with powerful cinematic tools."
      image={image}
      themeColor="#2196f3"
      bgGradient="linear-gradient(135deg, rgba(33,150,243,0.15), rgba(255,255,255,0))"
      features={[
  {
    "title": "Corporate Videos",
    "desc": "Produce high-quality internal and external videos for your company."
  },
  {
    "title": "Product Demos",
    "desc": "Showcase your products with dynamic angles and professional editing."
  },
  {
    "title": "Brand Presentations",
    "desc": "Build stunning visual presentations that convert leads and impress clients."
  },
  {
    "title": "Internal Communications",
    "desc": "Keep your team aligned with securely hosted, private company broadcasts."
  }
]}
    />
  );
};

export default BusinessIndustry;
